import { createAction, props } from '@ngrx/store';

import { IdentifierSearchResult } from '../../features/identifier/models/identifier-search-result.model';

export namespace IdentifierActions {
  export const Search = createAction('[Identifier] Search', props<{ list: string[] }>());
  export const SearchSuccess = createAction(
    '[Identifier] Search Success',
    props<{ result: IdentifierSearchResult; list: string[] }>()
  );
  export const SearchFail = createAction(
    '[Identifier] Search Fail',
    props<{ error: string | object }>()
  );

  export const ClearAll = createAction('[Identifier] Search Fail');
}
